// styles
import './styles/graphic.scss';

const months = [
  'Jan.',
  'Feb.',
  'March',
  'April',
  'May',
  'June',
  'July',
  'Aug.',
  'Sept.',
  'Oct.',
  'Nov.',
  'Dec.',
];

export default function (props, container, isMobile) {
  const {
    color,
    data,
    fmtYearAbbrev,
    fmtYearFull,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
  } = props;

  const xTicks = isMobile ? 5 : 10;
  const yTicks = 5;

  const xGrid = xAxis(x)
    .ticks(xTicks)
    .tickFormat(d => (isMobile
      ? `‘${fmtYearAbbrev(d)}`
      : fmtYearFull(d)));

  // legend
  container.append('div')
  		.attr('class', 'legend')
  	.selectAll('div')
  		.data(color.domain())
  	.enter()
    .append('div')
  		.html(d => `
  			<div class='key-block' style='background-color:${color(d)};'></div>
  			<div>${d.charAt(0).toUpperCase() + d.slice(1)}</div>
  		`);

  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  g.append('rect')
  	.attr('x', x(new Date('12/01/2007')))
  	.attr('width', x(new Date('07/01/2009')) - x(new Date('12/01/2007')))
  	.attr('height', height)
  	.attr('fill', '#eee');

  g.append('text')
  	.attr('x', x(new Date('07/01/2009')) - (x(new Date('07/01/2009')) - x(new Date('12/01/2007'))) / 2)
  	.attr('y', y(0.1))
  	.attr('text-anchor', 'middle')
  	.style('font-size', 12)
  	.text('Recession');

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);

 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y).ticks(yTicks));

  // hide first tick's text
  // yGrid.select('text');

  yGrid.selectAll('line').attr('x2', width);

  yGrid.selectAll('text')
  	.attr('x', -margins.left)
  	.attr('text-anchor', 'start')
  	.text(d => `${d}%`);

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'line');

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label');

  label.append('circle')
  	.attr('r', 3.5)
  	.attr('stroke', '#fff')
  	.attr('stroke-width', 1)
  	.attr('fill', d => color(d.id))
  	.attr('transform', (d) => {
  		const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
  		return `translate(${[x(d0.date), y(d0.value)]})`;
  	});

  label.append('text')
  	// .attr('dy', '.35em')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 6;
      const y0 = y(d0.value) + 3;
      return `translate(${[x0, y0]})`;
    })
    .html((d, i) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;

      if (i === 0) {
      	return `
      	<tspan x='0'>
      		${value.toFixed(1)}%
      	</tspan>
      	<tspan x='0' dy='1.15em'>
      		${months[d0.date.getMonth()]} ${d0.date.getDate()}, ‘${String(d0.date.getFullYear()).slice(-2)}
      	</tspan>
      	`;
      }

      if (i === 1) {
        return `
        <tspan x='0'>
          ${value.toFixed(1)}%
        </tspan>
        <tspan x='0' dy='1.15em'>
          ${months[d0.date.getMonth()]} ${d0.date.getDate()}, ‘${String(d0.date.getFullYear()).slice(-2)}
        </tspan>
        `;
      }

      return `${value.toFixed(1)}%`;
    });
}
